import TOOLS from '@helpers/tools'

const Cookies = require('js-cookie')
const _ = require('lodash')

const COOKIES = {
  set: function(name, value, expires) {
    if (expires) {
      Cookies.set(name, value, expires)
    } else {
      Cookies.set(name, value, { expires: 365 })
    }
  },
  setIfEmpty: function(name, value, expires) {
    if (_.isEmpty(COOKIES.get(name))) {
      this.set(name, value, expires)
    }
  },
  get: (name, defaultValue) => {
    const cookie = Cookies.get(name)
    return cookie ? cookie : defaultValue
  },
  getAll: () => {
    return Cookies.get()
  },
  remove: function(name) {
    Cookies.remove(name)
  },
  utmzCookieParse: (sourceCookie) => {
    let gaSend = {
      UtmSource: '',
      UtmCampaign: '',
      UtmMedium: '',
      UtmTerm: '',
      UtmContent: '',
      CodigoGa: '',
      UtmGclid: '',
    }

    if (!!sourceCookie && !_.isEmpty(sourceCookie)) {
      const sourceCookieParsed = TOOLS.createObjectFromQueryString(sourceCookie)
      const gclidGettingFromCookies = COOKIES.get('gclid')

      if (
        !!sourceCookieParsed &&
        !_.isEmpty(sourceCookieParsed) &&
        !!sourceCookieParsed.utmgclid
      ) {
        gaSend = COOKIES.gclidCookieParse(gclidGettingFromCookies, sourceCookieParsed.utmgclid)
      } else {
        gaSend.UtmSource = sourceCookieParsed.utmcsr ? sourceCookieParsed.utmcsr : ''
        gaSend.UtmCampaign = sourceCookieParsed.utmccn ? sourceCookieParsed.utmccn : ''
        gaSend.UtmMedium = sourceCookieParsed.utmcmd ? sourceCookieParsed.utmcmd : ''
        gaSend.UtmTerm = sourceCookieParsed.utmctr ? sourceCookieParsed.utmctr : ''
        gaSend.UtmContent = sourceCookieParsed.utmcct ? sourceCookieParsed.utmcct : ''
        gaSend.UtmGclid = sourceCookieParsed.utmgclid ? sourceCookieParsed.utmgclid : ''
      }
    }

    return gaSend
  },
  gclidCookieParse: (sourceCookie, gclid) => {
    let gaSend = {
      UtmSource: '',
      UtmCampaign: '',
      UtmMedium: '',
      UtmTerm: '',
      UtmContent: '',
      CodigoGa: '',
      UtmGclid: gclid || '',
    }
    if (!!sourceCookie && !_.isEmpty(sourceCookie)) {
      const sourceCookieParsed = TOOLS.createObjectFromQueryString(sourceCookie)

      gaSend.UtmSource = sourceCookieParsed.utm_source ? sourceCookieParsed.utm_source : ''
      gaSend.UtmCampaign = sourceCookieParsed.utm_campaign ? sourceCookieParsed.utm_campaign : ''
      gaSend.UtmMedium = sourceCookieParsed.utm_medium ? sourceCookieParsed.utm_medium : ''
      gaSend.UtmTerm = sourceCookieParsed.utm_term ? sourceCookieParsed.utm_term : ''
      gaSend.UtmContent = sourceCookieParsed.utm_content ? sourceCookieParsed.utm_content : ''
    }
    return gaSend
  },
  getUtmGaSend: () => {
    let gaSend = {
      UtmSource: '',
      UtmCampaign: '',
      UtmMedium: '',
      UtmTerm: '',
      UtmContent: '',
      CodigoGa: '',
      UtmGclid: '',
    }

    const gclidGettingFromCookies = COOKIES.get('gclid')
    const utmzGettingFromCookies = COOKIES.get('__utmz')

    let sourceCookie = !_.isEmpty(gclidGettingFromCookies) ?
      gclidGettingFromCookies : utmzGettingFromCookies

    if (!!sourceCookie && !_.isEmpty(sourceCookie)) {
      const sourceCookieParsed = TOOLS.createObjectFromQueryString(sourceCookie)

      const hasGclidParam = sourceCookieParsed.hasOwnProperty('utmgclid') && !!sourceCookieParsed['utmgclid']
      const hasUtmGclidParam = sourceCookieParsed.hasOwnProperty('utm_gclid') && !!sourceCookieParsed['utm_gclid']

      if (!(hasGclidParam || hasUtmGclidParam)) {
        const utmzCookieParsed = TOOLS.createObjectFromQueryString(utmzGettingFromCookies)
        sourceCookieParsed['utmgclid'] = !!utmzCookieParsed && !_.isEmpty(utmzCookieParsed) ? utmzCookieParsed.utmgclid : ''
      }

      gaSend.UtmSource = sourceCookieParsed.utm_source ? sourceCookieParsed.utm_source : sourceCookieParsed.utmcsr
      gaSend.UtmCampaign = sourceCookieParsed.utm_campaign ? sourceCookieParsed.utm_campaign : sourceCookieParsed.utmccn
      gaSend.UtmMedium = sourceCookieParsed.utm_medium ? sourceCookieParsed.utm_medium : sourceCookieParsed.utmcmd
      gaSend.UtmTerm = sourceCookieParsed.utm_term ? sourceCookieParsed.utm_term : sourceCookieParsed.utmctr
      gaSend.UtmContent = sourceCookieParsed.utm_content ? sourceCookieParsed.utm_content : sourceCookieParsed.utmcct
      gaSend.UtmGclid = sourceCookieParsed.utm_gclid ? sourceCookieParsed.utm_gclid : sourceCookieParsed.utmgclid
    }

    const clientIdGa = COOKIES.get('_ga')
    if (!!clientIdGa) {
      gaSend.CodigoGa = clientIdGa
    }

    return gaSend
  },
}
export default COOKIES



// WEBPACK FOOTER //
// ./src/helpers/cookies.js